<template>
  <v-container grid-list-md text-center v-if="isConfigLoaded">
    <v-card class="mx-auto" elevation="0">
      <v-window v-model="step">
        <!--SELECT UNIT-->
        <v-window-item :value="1">
          <v-card class="mx-auto" elevation="0">
            <div v-if="units.length > 0">
              <h2 class="text-xs-center">
                <span
                  v-html="this.getConfigItem('ENQUEUE_UNIT_HEADER_01')"
                ></span>
              </h2>
              <h4 class="text-xs-center">
                <span
                  v-html="this.getConfigItem('ENQUEUE_UNIT_HEADER_02')"
                ></span>
              </h4>
            </div>

            <div v-if="services.length > 0">
              <h2 class="text-xs-center">
                <span
                  v-html="this.getConfigItem('ENQUEUE_SERVICE_HEADER_01')"
                ></span>
              </h2>
              <h4 class="text-xs-center">
                <span
                  v-html="this.getConfigItem('ENQUEUE_SERVICE_HEADER_02')"
                ></span>
              </h4>
            </div>

            <v-list v-if="!isShowNoData">
              <!-- LIST TITLES -->
              <h4 class="text-xs-center">
                {{ this.getConfigItem("SELECTION_TEXT") }}
              </h4>

              <h2 class="text-xs-center" v-if="this.selectedUnit.Id > 0">
                {{ this.selectedUnit.Name }} Services
              </h2>

              <!-- LIST FOR UNITS -->
              <v-list-item
                v-if="
                  units.length > 0 &&
                  (this.getConfigItem('SHOW_WAIT_COUNT_UNIT', true) ||
                    this.getConfigItem('SHOW_WAIT_TIMES_UNIT', true))
                "
                class="primary--text"
                style="
                  margin: 16px;
                  margin-bottom: 0px;
                  margin-top: 0px;
                  height: 40px;
                  box-shadow: none;
                "
              >
                <v-list-item-content>
                  <v-list-item-title v-text="unitTitle"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-avatar
                  v-if="this.getConfigItem('SHOW_WAIT_COUNT_UNIT', true)"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-format-list-numbered</v-icon>
                    </template>
                    <span>{{
                      this.getConfigItem("TTIP_TICKET_QUEUE_TEXT")
                    }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-avatar
                  v-if="this.getConfigItem('SHOW_WAIT_TIMES_UNIT', true)"
                  min-width="70"
                  max-width="100"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-clock</v-icon>
                    </template>
                    <span>{{ this.getConfigItem("TTIP_AVG_TIME_TEXT") }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
              </v-list-item>

              <v-list-item
                v-for="unit in units"
                :key="unit.Id"
                @click="onSelectUnit(unit)"
                :style="{ 'background-color': SECONDARY_COLOUR }"
                style="margin: 16px"
              >
                <v-list-item-content>
                  <v-list-item-title
                    :style="{ color: SECONDARY_COLOUR_TEXT }"
                    class="text-left"
                    v-text="unit.Name"
                  ></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar
                  tile
                  v-if="getConfigItem('SHOW_WAIT_COUNT_UNIT', true)"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" label class="ml-0">{{
                        unit.WaitCount
                      }}</v-chip>
                    </template>
                    <span>{{ getConfigItem("TTIP_TICKET_QUEUE_TEXT") }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-avatar
                  tile
                  v-if="getConfigItem('SHOW_WAIT_TIMES_UNIT', true)"
                  min-width="70"
                  max-width="100"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" label class="ml-0">{{
                        unit.WaitTimeAvg | getShortFormattedWaitTimeFromSeconds
                      }}</v-chip>
                    </template>
                    <span>{{ getConfigItem("TTIP_AVG_TIME_TEXT") }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
              </v-list-item>

              <!-- LIST FOR SERVICES -->

              <v-list-item
                v-if="
                  services.length > 0 &&
                  (this.getConfigItem('SHOW_WAIT_COUNT_SERVICE', true) ||
                    this.getConfigItem('SHOW_WAIT_TIMES_SERVICE', true))
                "
                class="primary--text"
                style="
                  margin: 16px;
                  margin-bottom: 0px;
                  margin-top: 0px;
                  height: 40px;
                  box-shadow: none;
                "
              >
                <v-list-item-content>
                  <v-list-item-title v-text="unitTitle"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-avatar
                  v-if="this.getConfigItem('SHOW_WAIT_COUNT_SERVICE', true)"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-format-list-numbered</v-icon>
                    </template>
                    <span>{{
                      this.getConfigItem("TTIP_TICKET_QUEUE_TEXT")
                    }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-avatar
                  v-if="this.getConfigItem('SHOW_WAIT_TIMES_SERVICE', true)"
                  min-width="70"
                  max-width="100"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-clock</v-icon>
                    </template>
                    <span>{{ this.getConfigItem("TTIP_AVG_TIME_TEXT") }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
              </v-list-item>

              <v-list-item
                v-for="service in services"
                :key="service.ServiceId"
                @click="onSelectService(service)"
                :style="{ 'background-color': SECONDARY_COLOUR }"
                style="margin: 16px"
              >
                <v-list-item-content>
                  <div tooltip="Average wait time">
                    <v-list-item-title
                      :style="{ color: SECONDARY_COLOUR_TEXT }"
                      class="text-left"
                      v-text="service.Name"
                    ></v-list-item-title>
                  </div>
                </v-list-item-content>

                <v-list-item-avatar
                  tile
                  v-if="getConfigItem('SHOW_WAIT_COUNT_SERVICE', true)"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" label color="white" class="ml-0">{{
                        service.WaitCount
                      }}</v-chip>
                    </template>
                    <span>{{ getConfigItem("TTIP_TICKET_QUEUE_TEXT") }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-avatar
                  tile
                  v-if="getConfigItem('SHOW_WAIT_TIMES_SERVICE', true)"
                  min-width="70"
                  max-width="100"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" label color="white" class="ml-0">{{
                        service.WaitTimeAvg
                          | getShortFormattedWaitTimeFromSeconds
                      }}</v-chip>
                    </template>
                    <span>{{ getConfigItem("TTIP_AVG_TIME_TEXT") }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
              </v-list-item>

              <!-- LIST FOR CLASSIFICATION -->
              <v-list-item
                avatar
                v-for="classification in classifications"
                :key="classification.Code"
                @click="onSelectClassification(classification)"
                :style="{ 'background-color': SECONDARY_COLOUR }"
                style="margin: 16px"
              >
                <v-list-item-content>
                  <v-list-item-title
                    :style="{ color: SECONDARY_COLOUR_TEXT }"
                    class="text-left"
                    v-text="classification.Name"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <!-- Nothing available -->
            <div v-if="isShowNoData">
              <h3 class="text-xs-center">
                {{ this.getConfigItem("NO_SERVICE_TEXT") }}
              </h3>
              <br />
            </div>

            <!-- Back button -->
            <v-row row wrap>
              <v-col xs12 class="text-xs-center">
                <v-btn
                  :style="{ color: this.getConfigItem('INFO_COLOUR_TEXT') }"
                  color="info"
                  @click="stepBack()"
                  >{{ this.getConfigItem("BTN_BACK_TEXT") }}</v-btn
                >
              </v-col>
            </v-row>

            <!-- Bottom legend -->
            <div
              v-if="
                (isShowListLegend &&
                  this.getConfigItem('SHOW_WAIT_COUNT_UNIT', true) &&
                  units.length > 0) ||
                (this.getConfigItem('SHOW_WAIT_COUNT_SERVICE', true) &&
                  services.length > 0)
              "
              row
              wrap
              style="margin: 16px; background-color: #f3f3f3; padding: 16px"
              text-left
            >
              <v-row
                style="width: 100%; padding-left: 12px"
                v-if="
                  (this.getConfigItem('SHOW_WAIT_COUNT_UNIT', true) &&
                    units.length > 0) ||
                  (this.getConfigItem('SHOW_WAIT_COUNT_SERVICE', true) &&
                    services.length > 0)
                "
              >
                <v-icon small>mdi-format-list-numbered</v-icon>
                <span style="font-size: 10px; padding-left: 5px">{{
                  this.getConfigItem("TICKETS_INQUEUE_TEXT")
                }}</span>
              </v-row>
              <v-row
                style="width: 100%; padding-left: 12px"
                v-if="
                  (this.getConfigItem('SHOW_WAIT_TIMES_UNIT', true) &&
                    units.length > 0) ||
                  (this.getConfigItem('SHOW_WAIT_TIMES_SERVICE', true) &&
                    services.length > 0)
                "
              >
                <v-icon small>mdi-clock</v-icon>
                <span style="font-size: 10px; padding-left: 5px">{{
                  this.getConfigItem("AVG_TIME_TEXT")
                }}</span>
              </v-row>
            </div>
          </v-card>
        </v-window-item>

        <!--MOBILE NUMBER-->
        <v-window-item :value="2">
          <v-card class="mx-auto" elevation="0">
            <h2 class="text-xs-center">
              {{ this.getConfigItem("ENTER_MOBILE_INFO_TEXT") }}
            </h2>
            <br />
            <v-form
              ref="phoneForm"
              v-model="isPhonenumValid"
              lazy-validation
              @submit.prevent="confirmMobile()"
              id="confirmMobileForm"
            >
              <v-text-field
                v-model="inputPhonenum"
                type="number"
                :label="this.getConfigItem('PHOLDER_INPUTHERE_TEXT')"
                required
                :rules="phonenumRules"
                :hint="this.getConfigItem('MOBILENUM_HINT_TEXT')"
              ></v-text-field>
              <v-row row wrap>
                <v-col xs12 class="text-xs-center">
                  <v-btn
                    color="secondary"
                    class="ma-3"
                    :style="{
                      color: this.SECONDARY_COLOUR_TEXT,
                    }"
                    @click="stepBack()"
                    >{{ this.getConfigItem("BTN_BACK_TEXT") }}</v-btn
                  >
                  <v-btn
                    type="submit"
                    class="ma-3"
                    color="primary"
                    :style="{ color: this.PRIMARY_COLOUR_TEXT }"
                    >{{ this.getConfigItem("BTN_CONTINUE_TEXT") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>

<script>
import cookieMixin from "@/mixins/cookieMixin";
import configAliasMixin from "@/mixins/configAliasMixin";
import serviceMixin from "@/mixins/serviceMixin";
import loadingMixin from "@/mixins/loadingMixin";
import utilMixin from "@/mixins/utilMixin";
import enqueueCommonMixin from "@/mixins/enqueueCommonMixin";
import { mapGetters } from "vuex";
import { helper } from "@/helper";

export default {
  mixins: [
    configAliasMixin,
    cookieMixin,
    serviceMixin,
    loadingMixin,
    utilMixin,
    enqueueCommonMixin,
  ],
  data: function () {
    return {
      step: 1,

      unitHistory: [{ Id: 0 }],
      units: [],
      services: [],
      classifications: [],
      selectedUnit: null,
      selectedService: null,
      selectedClassification: null,
      currentUnitIndex: 0,

      isMobileConfirmed: false,
      isClickedLastStep: false,

      isPhonenumValid: false,
      inputPhonenum: "",
      phonenumRules: [],

      isShowListHeader: true,
      listHeader: [{}],
      unitTitle: "",

      isForward: true,
    };
  },
  watch: {
    isConfigLoaded() {
      if (this.isConfigLoaded) {
        this.phonenumRules = [
          (v) => !!v || this.getConfigItem("REQUIRED_TEXT"),
          (v) => /^04/.test(v) || this.getConfigItem("PHONE_MUST_START_TEXT"),
          (v) =>
            (v || "").length >= 10 ||
            this.getConfigItem("PHONE_MUST_EQUAL_TEXT"),
          (v) =>
            /^\d{1,10}$/.test(v) || this.getConfigItem("PHONE_MAX_NUMBER_TEXT"),
        ];
        this.loadUnits();
      }
    },
  },
  mounted: function () {
    let userCookie = helper.getUserCookie();

    if (userCookie && this.validatePhonenum(userCookie.mobile)) {
      this.inputPhonenum = userCookie.mobile;
    }
    if (this.isConfigLoaded) {
      this.phonenumRules = [
        (v) => !!v || this.getConfigItem("REQUIRED_TEXT"),
        (v) => /^04/.test(v) || this.getConfigItem("PHONE_MUST_START_TEXT"),
        (v) =>
          (v || "").length >= 10 || this.getConfigItem("PHONE_MUST_EQUAL_TEXT"),
        (v) =>
          /^\d{1,10}$/.test(v) || this.getConfigItem("PHONE_MAX_NUMBER_TEXT"),
      ];
      this.loadUnits();
    }
  },
  methods: {
    loadUnits() {
      let userCookie = helper.getUserCookie();
      this.selectedUnit = this.unitHistory[this.currentUnitIndex];
      this.classifications = [];
      let param = this.getConfigItem("FILTER_GROUP")
        ? { params: { group: userCookie.group } }
        : null;

      this.callGetService(
        this,
        "/Menu/Units/" + this.selectedUnit.Id,
        param,
        (response) => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("Load Units:", response.data);
          if (
            this.selectedUnit.Id == 0 &&
            this.getConfigItem("GEOFENCE_ENABLED", true)
          ) {
            //Showing all units
            navigator.geolocation.getCurrentPosition((position) => {
              if (process.env.VUE_APP_ISDEBUGGING)
                console.log(
                  "%c geofencing coords: " +
                    position.coords.latitude +
                    "," +
                    position.coords.longitude,
                  "color:lime",
                  {
                    geoCoordConfig,
                  }
                );

              try {
                var geoCoordConfig = JSON.parse(
                  this.$store.state.nexaConfig.GEOFENCE_COORDS
                );
              } catch (err) {
                this.showError("Geofencing config error", err);
              }

              var inRangeLocations = geoCoordConfig
                .filter((coordinate) => {
                  return this.isPointInCircle(
                    position.coords.latitude,
                    position.coords.longitude,
                    coordinate.lat,
                    coordinate.long,
                    this.$store.state.nexaConfig.GEOFENCE_RADIUS
                  );
                })
                .map((inRangeCoordinate) => {
                  return inRangeCoordinate.name;
                });
              if (
                inRangeLocations &&
                inRangeLocations.length > 0 &&
                inRangeLocations.filter(
                  (inRangeLocation) => inRangeLocation !== undefined
                ).length == 0
              ) {
                //no non-empty location
                console.log(
                  "%c Locations are in range but no Name attribute set in GeoFencing Coordinates.",
                  "color:red"
                );
              } else {
                this.units = response.data.filter((unit) => {
                  return inRangeLocations.includes(unit.Name);
                });
              }
              if (this.units.length == 0) {
                this.showGeoError();
              } else {
                this.loadServices(this.units);
              }
            });
          } else {
            this.units = response.data;
            this.loadServices(this.units);
          }
        },
        null,
        this.getConfigItem("LOAD_UNITS_TEXT")
      );
    },
    loadServices(unitsData) {
      let userCookie = helper.getUserCookie();
      let param = this.getConfigItem("FILTER_GROUP")
        ? { params: { group: userCookie.group } }
        : null;

      this.callGetService(
        this,
        "/Menu/Services/" + this.selectedUnit.Id,
        param,
        (response) => {
          this.services = response.data;
          this.isShowListHeader = true;

          if (process.env.VUE_APP_ISDEBUGGING) {
            console.log("%c Load Services:", "color:lightblue", {
              services: this.services,
            });
            console.log(
              "units.length:",
              this.units.length,
              " services.length:",
              this.services.length
            );
          }

          // Auto select unit:
          if (
            this.units.length === 1 &&
            this.services.length === 0 &&
            this.getConfigItem("AUTOSELECT_UNIT", true)
          ) {
            // only 1 unit and no other services, autoselect unit:
            if (this.isForward) this.onSelectUnit(this.units[0]);
            return;
          }

          if (
            this.units.length === 0 &&
            this.services.length === 1 &&
            this.getConfigItem("AUTOSELECT_SERVICE", true) &&
            this.services[0].Autoselectable.toString().toUpperCase() == "TRUE"
          ) {
            if (process.env.VUE_APP_ISDEBUGGING)
              console.log("loadServices - no units, services.length == 1");

            if (this.isForward) {
              this.onSelectService(this.services[0]);
            } else {
              this.stepBack();
            }
          }
        },
        null,
        this.getConfigItem("LOAD_SERVICES_TEXT")
      );
    },
    loadClassifications() {
      this.callGetService(
        this,
        "/Menu/Classifications/" + this.selectedService.ServiceId,
        null,
        (response) => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("loadClassifications() ajax complete", response.data);
          if (response.data.length > 0) {
            this.unitHistory.push(this.selectedUnit);
            this.currentUnitIndex++;

            this.units = [];
            this.services = [];
            this.classifications = response.data;
            this.isShowListHeader = false;
          } else {
            this.preCheckMobile();
          }
        },
        null,
        this.getConfigItem("LOAD_CLASSIFICATIONS_TEXT")
      );
    },
    onSelectUnit(item) {
      this.selectedUnit = item;
      this.isForward = true;
      this.unitHistory.push(this.selectedUnit);
      this.currentUnitIndex++;
      this.loadUnits();
    },
    onSelectService(item) {
      this.selectedService = item;
      this.isForward = true;

      if (this.getConfigItem("USE_CLASSIFICATIONS")) {
        this.loadClassifications();
        return;
      }
      this.preCheckMobile();
    },
    onSelectClassification(item) {
      this.selectedClassification = item;
      this.isForward = true;

      this.preCheckMobile();
    },

    preCheckMobile() {
      if (process.env.VUE_APP_ISDEBUGGING) {
        console.log(
          "preCheckMobile() - isMobileConfirmed:" +
            this.isMobileConfirmed +
            " SKIP_MOBILE_CONF:" +
            this.getConfigItem("SKIP_MOBILE_CONF", true)
        );
      }

      if (
        this.isMobileConfirmed ||
        this.getConfigItem("SKIP_MOBILE_CONF", true)
      ) {
        if (process.env.VUE_APP_ISDEBUGGING) {
          console.log("CheckMobile: Confirmed or skip");
        }
        this.submitRequest();
        return;
      }

      this.step = 2;
    },

    stepBack() {
      if (process.env.VUE_APP_ISDEBUGGING) {
        console.log("%c stepBack()", "color:cyan", {
          step: this.step,
          unitHistory: this.unitHistory,
          currentUnitIndex: this.currentUnitIndex,
        });
      }
      this.isForward = false;
      if (this.step > 1) {
        this.step--;
        return;
      }

      this.unitHistory.pop();
      this.currentUnitIndex--;

      if (
        this.getConfigItem("AUTOSELECT_UNIT", true) &&
        this.unitHistory.length == 1
      ) {
        this.$router.push("/");
        return;
      }

      if (this.unitHistory.length <= 0) {
        this.$router.push("/");
      } else {
        this.loadUnits();
      }
    },
    submitRequest() {
      if (process.env.VUE_APP_ISDEBUGGING) console.log("submitRequest()");
      if (!this.isClickedLastStep) {
        this.isClickedLastStep = true;
        if (
          this.$refs.phoneForm != null &&
          !this.$refs.phoneForm.validate() &&
          !this.isMobileConfirmed &&
          !this.getConfigItem("SKIP_MOBILE_CONF", true)
        ) {
          return;
        }

        let userCookie = helper.getUserCookie();

        // SUBJECT & EXT REF TEMPLATE --------------------------------------------------
        let valueObj = {};
        valueObj.personalId =
          userCookie && userCookie.userName ? userCookie.userName : "";
        valueObj.mobile = this.inputPhonenum ? this.inputPhonenum : "";
        valueObj.name = this.fullName ? this.fullName : "";
        valueObj.classification = this.selectedClassification
          ? this.selectedClassification.Name
          : "";

        let subject = this.getConfigItem("SUBJECT_TEMPLATE");
        // console.log("%c Enqueue Subject", "color:yellow", valueObj);
        subject = this.updateTemplate(subject, valueObj);

        // console.log("%c Enqueue subejct post entries", "color:yellow", subject);
        //Remove blank brackets:
        if (this.getConfigItem("SUBJECT_REMOVEBLANKS", true)) {
          subject = subject.split("[]").join("");
        }

        let extRef = this.getConfigItem("EXTREF_TEMPLATE");
        extRef = this.updateTemplate(extRef, valueObj);
        //------------------------------------------------------------------------------

        let emailAddress =
          userCookie && userCookie.email ? userCookie.email : "";
        if (emailAddress == "" && userCookie && userCookie.emailAddress)
          emailAddress = userCookie.emailAddress;

        let customProperties = this.getCustomProperties();

        let postParam = {
          ServiceId: this.selectedService.ServiceId,
          ExtRef: extRef,
          Notes: "",
          Subject: subject,
          CustomProperties: customProperties,
        };

        let classificationStr = this.selectedClassification
          ? this.selectedClassification.Name
          : "";

        if (this.selectedClassification) {
          classificationStr = this.selectedClassification.Name;
          postParam["ClassificationCode"] = this.selectedClassification.Code;
        }

        if (this.getConfigItem("USE_CUSTOMER_RECORD", true)) {
          this.postQueueWithCustomerId(postParam, classificationStr);
        } else {
          this.postQueue(postParam, classificationStr);
        }
      }
    },
    postQueueWithCustomerId(postParam, classificationStr) {
      let customerParam = {
        IsActive: true,
        CustomProperties: {},
      };

      let userCookie = helper.getUserCookie();
      customerParam.PersonalId = userCookie.studentId
        ? userCookie.studentId
        : userCookie.mobile;
      if (userCookie.firstName) customerParam.FirstName = userCookie.firstName;
      if (userCookie.lastName) customerParam.LastName = userCookie.lastName;
      if (userCookie.email) customerParam.Email = userCookie.email;
      if (userCookie.mobile) customerParam.TelNumber1 = userCookie.mobile;

      this.callPostService(
        this,
        "/Customers",
        customerParam,
        (response) => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("response", { response });
          if (response.status == 200) {
            // OK - not created new
            this.$store.commit("existingTicket", true);
          }
          let data = response.data;

          postParam.CustomerId = data.CustomerId;

          this.postQueue(postParam, classificationStr);
        },
        null,
        this.getConfigItem("REQUEST_TICKET_TEXT")
      );
    },
    postQueue(postParam, classificationStr) {
      this.callPostService(
        this,
        "/Cases",
        postParam,
        (response) => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("response", { response });
          if (response.status == 200) {
            // OK - not created new
            this.$store.commit("existingTicket", true);
          }
          let data = response.data;

          if (data.CaseId) {
            helper.setCaseCookie(
              data.CaseId,
              false,
              this.selectedUnit.Name,
              classificationStr,
              this.getConfigItem("DATA_RETENTION_PERIOD")
            );
            this.$router.push("EnqueueInfo");

            localStorage.selectedUnit = JSON.stringify(this.selectedUnit);
          }
        },
        null,
        this.getConfigItem("REQUEST_TICKET_TEXT")
      );
    },
    showGeoError() {
      this.$store.commit("showOverlay", {
        overlayTitle: "Location Policy",
        overlayMessage: this.$store.state.nexaConfig.GEOFENCE_TEXT,
        solveMethod: () => {
          this.refreshHome();
        },
        buttonLabel: "Try again",
      });
    },
  },
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
    USE_CLASSIFICATIONS() {
      return this.getConfigItem("USE_CLASSIFICATIONS").toLowerCase() == "true";
    },
    isShowNoData() {
      if (!this.isConfigLoaded) return true;

      let result =
        (!this.USE_CLASSIFICATIONS &&
          this.units.length == 0 &&
          this.services.length == 0) ||
        (this.USE_CLASSIFICATIONS &&
          this.units.length == 0 &&
          this.services.length == 0 &&
          this.classifications.length == 0);

      // if (process.env.VUE_APP_ISDEBUGGING)
      //   console.log("isShowNoData()", result);

      return result;
    },
  },
};
</script>
